import React, { FunctionComponent, ReactNode } from 'react';

import styles from './OurCommunity.module.scss';

interface OurCommunityProps {
  className?: string;
  blockquoteDescription?: string;
  figcaption?: string;
  children?: ReactNode;
}

export const OurCommunityCard: FunctionComponent<OurCommunityProps> = ({
  className,
  blockquoteDescription,
  figcaption,
  children,
}) => {
  return (
    <figure className={className}>
      <blockquote>
        <p className={`jg-text-l ${styles.communityCommentQuote}`}>
          {blockquoteDescription}
        </p>
      </blockquote>
      <figcaption
        className={`jg-text-default-regular ${styles.communityCommentName}`}
      >
        {figcaption}
      </figcaption>
      {children}
    </figure>
  );
};
